const stats = [
  { icon: "ri-award-fill", value: "10+", label: "Years in Real Estate", desc: "Trusted Bengaluru developer since 2016" },
  { icon: "ri-building-4-fill", value: "9+", label: "Projects Developed", desc: "Across Bengaluru's prime corridors" },
  { icon: "ri-map-pin-2-fill", value: "2", label: "Bengaluru-Focused Corridor", desc: "Sarjapur Road, Bengaluru expertise" },
  { icon: "ri-home-heart-fill", value: "500+", label: "Residential Communities", desc: "Families living in our developments" },
];

export default function AboutStats() {
  return (
    <section className="bg-[#1B2A4A] py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-bold uppercase tracking-widest text-[#7FBF3F] bg-white/10 px-3 py-1.5 rounded-full mb-4">
            By the Numbers
          </span>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-white" style={{ fontFamily: "'Playfair Display', serif" }}>
            Our Track Record Speaks
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat) => (
            <div key={stat.label} className="group bg-white/10 hover:bg-white/15 border border-white/10 hover:border-[#7FBF3F]/30 rounded-2xl p-7 text-center transition-all duration-300">
              <div className="w-14 h-14 flex items-center justify-center bg-[#7FBF3F]/20 rounded-full mx-auto mb-4 group-hover:bg-[#7FBF3F]/30 transition-colors duration-300">
                <i className={`${stat.icon} text-2xl text-[#7FBF3F]`}></i>
              </div>
              <div className="font-serif text-4xl font-bold text-white mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>{stat.value}</div>
              <div className="text-sm font-semibold text-white/80 mb-1">{stat.label}</div>
              <div className="text-xs text-white/50">{stat.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
